var React = require('react');

function StarUnique (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"100%","height":"100%","fill":"#080808","key":0}),React.createElement("linearGradient",{"id":"warm_glow_gradient","className":"test","key":1},[React.createElement("stop",{"offset":"0","stopColor":"#F81","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#EEC","key":1})]),React.createElement("polygon",{"points":"\n      50,10\n      58.8,35\n      88.0,37.6\n      64.3,54.6\n      73.5,82.4\n      50,65\n      26.5,82.4\n      35.7,54.6\n      12.0,37.6\n      41.2,35\n    ","id":"the-five-point-star","className":"a-five-point-star","fill":"url(#warm_glow_gradient)","key":2})]);
}

StarUnique.defaultProps = {"viewBox":"0 0 100 100","className":"a-class-added","title":"a-title-added"};

module.exports = StarUnique;

StarUnique.default = StarUnique;
